<template>
    <input :type="inputType" :required="inputRequired" :placeholder="inputPlaceholder">
</template>

<script>
export default {
    props:{
        inputType: null,
        inputPlaceholder: null,
        inputRequired: true,
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/blocks/BaseInput.vue